import React from 'react'
import CustomCarousel from './CustomCarousel'
import Section from './Section'

import Services from './Services'
import Videosection from './Videosection'
import ReviewsSlider from './ReviewsSlider'
import Footer from './Footer'
import Map from './Map'
import Blog from './Blog'
import Header from './Header'
import Containe from '../Treatments/Containe'
import Banner from '../Treatments/Banner'



const Layout = () => {
  return (
    <div className='main'>
      <Header />

      <Containe />

      <Banner />
      <Services />


      {/* <CustomCarousel />
      <Section />
     
      <Services />
      <Blog />
      <Videosection />
      <ReviewsSlider /> */}





      <br />
      <Map />
      <Footer />

    </div>
  )
}

export default Layout
